"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useColorPalette = exports.ColorPaletteProvider = void 0;
var tslib_1 = require("tslib");
// (C) 2020 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var ColorPaletteContext = react_1.default.createContext(undefined);
ColorPaletteContext.displayName = "ColorPaletteContext";
/**
 * @internal
 */
exports.ColorPaletteProvider = function (_a) {
    var children = _a.children, palette = _a.palette;
    return react_1.default.createElement(ColorPaletteContext.Provider, { value: palette }, children);
};
/**
 * @internal
 */
exports.useColorPalette = function () {
    return react_1.default.useContext(ColorPaletteContext);
};
//# sourceMappingURL=ColorPaletteContext.js.map